export enum Fansea3DStageTheme {
  Dark,
  Light,
}
